import { Outlet, createRootRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { isConfigured } from '@/lib/supabase';
import { AlertBanner } from '@/components/ui/display';

function Root() {
  return (
    <>
      {!isConfigured && !sessionStorageHas('aslen.preview') && <ConfigWarning />}
      <Outlet />
    </>
  );
}

function ConfigWarning() {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-x-0 top-0 z-[70] p-2">
      <AlertBanner tone="warning" title={t('app.notConfigured.title')}>
        {t('app.notConfigured.body', { file: 'apps/web/.env.local', urlVar: 'VITE_SUPABASE_URL', keyVar: 'VITE_SUPABASE_ANON_KEY' })}
      </AlertBanner>
    </div>
  );
}

function sessionStorageHas(k: string) {
  try {
    return sessionStorage.getItem(k) === '1';
  } catch {
    return false;
  }
}

export const Route = createRootRoute({ component: Root });
